import ProfileAvatarPicker from './ProfileAvatarPicker'
import { useBackdropDismiss } from '../hooks/useBackdropDismiss'
import './AvatarPickerModal.css'

/**
 * Modale dédiée au choix d’avatar (au-dessus du modal profil le cas échéant).
 */
export default function AvatarPickerModal({
  isOpen,
  onClose,
  user,
  userData,
  isAdminTeacher
}) {
  const backdropDismiss = useBackdropDismiss(onClose)
  if (!isOpen) return null

  return (
    <div className="avatar-picker-modal-backdrop" {...backdropDismiss} role="presentation">
      <div
        className="avatar-picker-modal-panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="avatar-picker-modal-title"
      >
        <div className="avatar-picker-modal-header">
          <h2 id="avatar-picker-modal-title">Changer l’image de profil</h2>
          <button
            type="button"
            className="avatar-picker-modal-close"
            onClick={onClose}
            aria-label="Fermer"
          >
            ×
          </button>
        </div>
        <div className="avatar-picker-modal-body">
          <ProfileAvatarPicker
            variant="modal"
            user={user}
            userData={userData}
            isAdminTeacher={isAdminTeacher}
            showTitle={false}
            onAfterPick={onClose}
          />
        </div>
      </div>
    </div>
  )
}
